import React, { createContext, useContext, useState, ReactNode } from 'react';

interface RangeDateTypes {
  initial_date: string | null;
  end_date: string | null;
}

interface FilterContextType {
  filters: {
    year: any[];
    state: any[];
    city: any[];
    position?: any[];
    party: any[];
    candidate?: any[];
    neighborhood: any[];
    round?: any[];
  };
  setFilters: (filters: FilterContextType['filters']) => void;
  filterMentions: string;
  setFilterMentions: (filter: string) => void;
  rangeDate: RangeDateTypes;
  handleRangeDate: (date: RangeDateTypes) => void;
  filterRaioX: string;
  setFilterRaioX: (filter: string) => void;
  renderFilter: boolean;
  setRenderFilter: (value: boolean) => void;
}

const FilterGlobalContext = createContext<FilterContextType | undefined>(undefined);

export const FilterGlobalProvider = ({ children }: { children: ReactNode }) => {
  const [filters, setFilters] = useState<FilterContextType['filters']>({
    year: [],
    state: [],
    city: [],
    position: [],
    party: [],
    candidate: [],
    neighborhood: [],
    round: [],
  });

  const [filterMentions, setFilterMentions] = useState('all');
  const [rangeDate, setRangeDate] = useState<RangeDateTypes>({
    initial_date: null,
    end_date: null,
  });
  const [filterRaioX, setFilterRaioX] = useState('all');
  const [renderFilter, setRenderFilter] = useState(false);

  const handleRangeDate = (date: RangeDateTypes) => {
    setRangeDate(date);
  };

  return (
    <FilterGlobalContext.Provider
      value={{
        filters,
        setFilters,
        filterMentions,
        setFilterMentions,
        rangeDate,
        handleRangeDate,
        filterRaioX,
        setFilterRaioX,
        renderFilter,
        setRenderFilter,
      }}
    >
      {children}
    </FilterGlobalContext.Provider>
  );
};

export const useFilterGlobal = (): FilterContextType => {
  const context = useContext(FilterGlobalContext);
  if (!context) {
    throw new Error('useFilterGlobal must be used within a FilterGlobalProvider');
  }
  return context;
};
